import { useState } from 'react'
import { Title } from '../../components/Title'

export const HomeSystem = () => {
    const [showModal, setShowModal] = useState(false)
    const [modalImage, setModalImage] = useState()
    const handleOpenModal = (imagepath) => {
        setModalImage(imagepath)
        setShowModal(true)
    }
    const handleCloseModal = () => {
        setShowModal(false)
    }

    const systemtext = [
        {
            data: 5,
            text: 'A free-movement Strategy RPG!',
            desc: 'Characters can move freely within a radius during combat.',
        },
        {
            data: 6,
            text: 'Use the “Confine” feature to possess trees, rocks, and other objects on the map!',
            desc: "Thanks to Marona's power, allied Phantoms can possess (Confine) objects on the map, like trees and rocks, to participate in battle.",
        },
        {
            data: 7,
            text: 'Confriend: The power of bonds that can drastically turn the tide of battle!',
            desc: "Marona can use a special version of Confine called Confriend to allow an allied Phantom to possess her. Marona's appearance will also change depending on the ally used to Confriend!",
        },
        {
            data: 8,
            text: 'Play it your way!',
            desc: 'Phantom Brave: The Lost Hero features a plethora of cutting-edge features! Equip items found on the battlefield, throw enemies in your way off the map entirely, stack characters on top of each other to reach high places, and more!',
        },
    ]
    return (
        <div className='my-20 md:my-40 px-4'>
            <Title title='System' />
            <div className='flex flex-wrap relative gap-12 justify-center mt-20 px-4 md:px-0'>
                {systemtext.map((system, i) => (
                    <>
                        <div
                            onClick={() => {
                                handleOpenModal(i + 5)
                            }}
                            className='w-full md:w-[46%] relative'
                        >
                            <p className='absolute text-topsystemMobile lg:text-topsystem text-gradient-homesystem font-pop -top-4 -left-4 -rotate-2'>
                                {system.text}
                            </p>
                            <img
                                className='ss-thumb'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-top-${i + 5}-s.webp`}
                                alt={system.text}
                            />{' '}
                            <h1 className='text-sub font-kiwi text-tilted-system text-shadow-white'>{system.desc}</h1>
                        </div>
                    </>
                ))}
            </div>
            <div
                onClick={handleCloseModal}
                className={`z-50 fixed top-0 left-0 w-full h-full bg-black/80 ${showModal ? 'block' : 'hidden'}`}
            >
                <div
                    onClick={(e) => e.stopPropagation()}
                    className='w-full md:w-[90%] absolute top-1/2 left-1/2 -translate-y-1/2 -translate-x-1/2 m-auto z-30'
                >
                    <div className='flex flex-row items-center mx-auto md:gap-4'>
                        <div>
                            {modalImage <= 5 ? (
                                <button>
                                    <img
                                        className='w-full brightness-50 min-w-[30px]'
                                        src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                        alt={`left`}
                                    />
                                </button>
                            ) : (
                                <button onClick={() => setModalImage(modalImage - 1)} className=''>
                                    <img
                                        className='w-full min-w-[30px]'
                                        src={`${process.env.PUBLIC_URL}/images/arrow_left.png`}
                                        alt={`left`}
                                    />{' '}
                                </button>
                            )}
                        </div>
                        <div className='relative'>
                            <button
                                onClick={handleCloseModal}
                                className='absolute top-0 right-0 -translate-y-full translate-x-1/4 md:-translate-y-full md:translate-x-full'
                            >
                                <img className='' src={`${process.env.PUBLIC_URL}/images/close.png`} alt={`close`} />{' '}
                            </button>
                            <img
                                className='white-drop-shadow'
                                src={`${process.env.PUBLIC_URL}/images/ss/ss-top-${modalImage}.webp`}
                                alt={`screen shot of game system`}
                            />{' '}
                        </div>
                        <div>
                            {modalImage > 7 ? (
                                <button>
                                    <img
                                        className='w-full brightness-50 min-w-[30px]'
                                        src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                        alt={`right`}
                                    />
                                </button>
                            ) : (
                                <button onClick={() => setModalImage(modalImage + 1)} className=' '>
                                    <img
                                        className='w-full min-w-[30px]'
                                        src={`${process.env.PUBLIC_URL}/images/arrow_right.png`}
                                        alt={`right`}
                                    />
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>{' '}
        </div>
    )
}
